import React, { useState } from "react";
import {
  Box,
  Button,
  FormControl,
  FormLabel,
  Input,
  Textarea,
  Select,
  Checkbox,
  Stack,
  useToast,
  Heading,
} from "@chakra-ui/react";
import Card from "components/card/Card.js";
import { useSendAnnouncement } from "api/admin";

export default function Notifications(): JSX.Element {
  const [title, setTitle] = useState("");
  const [body, setBody] = useState("");
  const [audience, setAudience] = useState("all");
  const [push, setPush] = useState(true);
  const [email, setEmail] = useState(false);

  const sendMut = useSendAnnouncement();
  const toast = useToast();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!title || !body) {
      toast({ title: "Title and body are required", status: "warning", isClosable: true });
      return;
    }

    const channels = [];
    if (push) channels.push("push");
    if (email) channels.push("email");

    if (channels.length === 0) {
      toast({ title: "Select at least one channel", status: "warning", isClosable: true });
      return;
    }

    try {
      await sendMut.mutateAsync({ title, body, audience, channels });
      toast({ title: "Announcement sent!", status: "success", isClosable: true });
      setTitle("");
      setBody("");
    } catch (err) {
      toast({ title: "Failed to send announcement", status: "error", isClosable: true });
    }
  };

  return (
    <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
      <Card p="24px" maxW="600px">
        <Heading size="md" mb="6">Send Global Announcement</Heading>
        <form onSubmit={handleSubmit}>
          <Stack spacing={4}>
            <FormControl isRequired>
              <FormLabel>Title</FormLabel>
              <Input value={title} onChange={(e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => setTitle(e.target.value)} />
            </FormControl>

            <FormControl isRequired>
              <FormLabel>Message Body</FormLabel>
              <Textarea value={body} onChange={(e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => setBody(e.target.value)} rows={5} />
            </FormControl>

            <FormControl>
              <FormLabel>Audience</FormLabel>
              <Select value={audience} onChange={(e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => setAudience(e.target.value)}>
                <option value="all">All (Users & Vendors)</option>
                <option value="users">Users Only</option>
                <option value="vendors">Vendors Only</option>
              </Select>
            </FormControl>

            <FormControl>
              <FormLabel>Channels</FormLabel>
              <Stack direction="row" spacing={4}>
                <Checkbox isChecked={push} onChange={(e: React.ChangeEvent<HTMLInputElement>) => setPush(e.target.checked)}>Push Notification</Checkbox>
                <Checkbox isChecked={email} onChange={(e: React.ChangeEvent<HTMLInputElement>) => setEmail(e.target.checked)}>Email</Checkbox>
              </Stack>
            </FormControl>

            <Button type="submit" colorScheme="brand" isLoading={sendMut.isLoading} mt="4">
              Send Announcement
            </Button>
          </Stack>
        </form>
      </Card>
    </Box>
  );
}
